module.exports = __webpack_public_path__ + "media/assets/images/smart_working/4-2-c6b93a3f5481cd3da400ec0d7918d2ab.png";